// extracted by mini-css-extract-plugin
export var styledTitle = "styled-title-module--styledTitle--b5705";